
import React, { Component } from 'react';
import { getCookie } from './../hook';

const Auth = ( InnerComponent ) => class extends Component {

    componentWillMount(){
        this.handleCookie( this.props );
    }

    componentWillReceiveProps( nextProps ) {
        this.handleCookie(nextProps);
    }

    handleCookie( data ) {

        sessionStorage.setItem( 'current_route_path', data.location.pathname );

        if( !getCookie('dv_hrms_auth') ){
            data.history.push('/login');
        }

        const getUser = getCookie('dv_hrms_user').split(',');

        if( data.location.pathname === "/organization/employees" ||
            data.location.pathname === "/organization/companyprofile" ||
            data.location.pathname === "/organization/department" ||
            data.location.pathname === "/organization/designation" ||
            data.location.pathname === "/organization/leavetype" ||
            data.location.pathname === "/organization/holidays" ||
            data.location.pathname === "/organization/groups" ||
            data.location.pathname === "/organization/announcements" ||
            data.location.pathname === "/hr-reports" ||
            data.location.pathname === "/hr-reports/meetings" ) {

            if( getUser[3] !== 'admin' ){
                data.history.push('/');
            }

        }

        if( data.location.pathname === "/approvals" ||
            data.location.pathname === "/requests/onboarding" ){
            
            if( getUser[3] !== 'admin' && getUser[3] !== 'manager' && getUser[3] !== 'director' ){
                data.history.push('/');
            }

        }

    }

    render(){
        return(
            <InnerComponent { ...this.props } { ...this.state } />
        )
    }

}

export default Auth;



// WEBPACK FOOTER //
// ./src/auth/index.js